import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from "react-icons/fa";
import { Link } from "react-router-dom";
import {
  APP_VERSION,
  RELEASE_STAGE,
  LAST_UPDATED,
} from "../constants/releaseInfo";

const formatLastUpdated = (isoDate) =>
  new Date(`${isoDate}T12:00:00`).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

const Footer = () => {
    return (
        <footer className="bg-gray-800 text-gray-300 pt-12 pb-6 px-6 md:px-16">
            <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8">

                {/* Logo & Description */}
                <div>
                    <h1 className="text-2xl font-bold text-white mb-4">RealHired</h1>
                    <p className="text-sm text-gray-400">
                        Building modern solutions for real-world problems. Let’s grow together.
                    </p>
                </div>

                {/* Quick Links */}
                <div>
                    <h2 className="text-lg font-semibold text-white mb-4">Quick Links</h2>
                    <ul className="space-y-2 text-sm">
                        <li><a href="#" className="hover:text-white transition">Home</a></li>
                        <li><Link to="/about" className="hover:text-white transition">About</Link></li>
                        <li><a href="#" className="hover:text-white transition">Services</a></li>
                        <li><a href="#" className="hover:text-white transition">Blog</a></li>
                    </ul>
                </div>

                {/* Resources */}
          {/* Resources */}
<div>
    <h2 className="text-lg font-semibold text-white mb-4">Resources</h2>
    <ul className="space-y-2 text-sm">

        <li>
            <Link 
                to="/privacy-policy"
                className="hover:text-white transition"
            >
                Privacy Policy
            </Link>
        </li>

        <li>
            <Link 
                to="/terms"
                className="hover:text-white transition"
            >
                Terms of Service
            </Link>
        </li>

        <li>
            <Link 
                to="/help"
                className="hover:text-white transition"
            >
                Help Center
            </Link>
        </li>

        <li>
            <Link 
                to="/faqs"
                className="hover:text-white transition"
            >
                FAQs
            </Link>
        </li>

    </ul>
</div>


                {/* Social & Newsletter */}
                <div>
                    <h2 className="text-lg font-semibold text-white mb-4">Connect With Us</h2>
                    <div className="flex space-x-3 mb-4">
                        <a href="#" className="p-2 bg-gray-700 rounded-full hover:bg-gray-600 transition">
                            <FaFacebookF />
                        </a>
                        <a href="#" className="p-2 bg-gray-700 rounded-full hover:bg-gray-600 transition">
                            <FaTwitter />
                        </a>
                        <a href="#" className="p-2 bg-gray-700 rounded-full hover:bg-gray-600 transition">
                            <FaLinkedinIn />
                        </a>
                        <a href="#" className="p-2 bg-gray-700 rounded-full hover:bg-gray-600 transition">
                            <FaInstagram />
                        </a>
                    </div>
                    <p className="text-sm text-gray-400">Stay updated with our latest news.</p>
                </div>
            </div>

            {/* Footer Bottom */}
            <div className="mt-10 border-t border-gray-700 pt-5 text-center text-sm text-gray-500 space-y-1">
                <p>© 2026 RealHired. All rights reserved.</p>
                <p className="text-xs text-gray-500">
                    v{APP_VERSION}-{RELEASE_STAGE} · Creation build · Last updated{" "}
                    {formatLastUpdated(LAST_UPDATED)}
                </p>
            </div>
        </footer>
    );
};

export default Footer;
